import template from './MessageTemplateItemView.html';
import { MessageTemplateItemController } from './MessageTemplateItemController';
export const MessageTemplateItemComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller: MessageTemplateItemController,
    controllerAs: '$ctrl',
    template,
    bindings: {
        data: '<',
        elementId: '@?',
        onDuplicate: '&?',
    },
};
